export const ORGANIZATION_SCHOOL_OPTION_OPEN_FORM_FIELD_TEXT = `Open Form Field`
export const ORGANIZATION_SCHOOL_OPTION_DEFAULT_TEXT = `Toronto District School Board(default)`
export const ORGANIZATION_SCHOOL_OPTION_DISABLED_TEXT = `Don't show School Option`

export const LOCALIZATION_CANADA = `Canada`
export const LOCALIZATION_USA = `United States (USA)`